var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError403Manhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 152,
    viewBox: "0 0 441 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 118.442V91.4403L61.8299 3H99.2018V89.4836H115.246V118.442H99.2018V143.878H65.7432V118.442H0ZM68.0912 39.7849L35.2196 89.4836H68.0912V39.7849Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.806 151.14C275.716 151.14 315.366 131.315 315.366 106.86C315.366 82.4046 275.716 62.5798 226.806 62.5798C177.896 62.5798 138.246 82.4046 138.246 106.86C138.246 131.315 177.896 151.14 226.806 151.14Z",
    fill: "#86A5BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.806 148.56C275.716 148.56 315.366 128.735 315.366 104.28C315.366 79.8248 275.716 60 226.806 60C177.896 60 138.246 79.8248 138.246 104.28C138.246 128.735 177.896 148.56 226.806 148.56Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.87 81.2278C202.648 66.3204 250.963 66.3204 280.741 81.2278C294.653 88.1748 302.061 97.1303 302.982 106.233C304.088 95.8404 296.717 85.2633 280.741 77.3029C250.963 62.4139 202.74 62.4139 172.87 77.3029C156.967 85.2633 149.56 95.8404 150.628 106.233C151.55 97.1303 158.957 88.1748 172.87 81.2278Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.87 131.257C202.648 146.146 250.964 146.146 280.742 131.257C294.654 124.31 302.062 115.281 302.983 106.233C302.062 97.1303 294.654 88.1748 280.742 81.2279C250.964 66.3205 202.74 66.3205 172.87 81.2279C158.958 88.1748 151.55 97.1303 150.629 106.233C151.55 115.281 158.958 124.31 172.87 131.257Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.146 143.968C271.873 143.968 308.132 125.838 308.132 103.475C308.132 81.1108 271.873 62.9813 227.146 62.9813C182.418 62.9813 146.159 81.1108 146.159 103.475C146.159 125.838 182.418 143.968 227.146 143.968Z",
    fill: "url(#paint4_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.502 134.803C260.117 134.803 287.368 120.769 287.368 103.457C287.368 86.1453 260.117 72.1112 226.502 72.1112C192.887 72.1112 165.636 86.1453 165.636 103.457C165.636 120.769 192.887 134.803 226.502 134.803Z",
    fill: "#476073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.534 80.0519C149.724 92.9176 150.939 112.163 178.395 125.704C205.851 139.246 246.974 138.57 274.784 125.704C302.594 112.839 305.105 94.8636 277.649 81.3384C250.193 67.8133 205.36 67.2183 177.534 80.0519ZM237.771 79.8267C238.311 78.91 240.316 78.3793 242.272 78.6527C244.227 78.9261 245.39 79.9071 244.783 80.8399C244.176 81.7727 242.221 82.3034 240.266 82.03C238.311 81.7566 237.232 80.8399 237.771 79.8267ZM192.147 123.249C191.326 123.583 190.443 123.756 189.551 123.756C188.659 123.756 187.776 123.583 186.955 123.249C185.54 122.541 185.54 121.431 186.955 120.772C187.774 120.43 188.658 120.254 189.551 120.254C190.444 120.254 191.328 120.43 192.147 120.772C193.613 121.447 193.596 122.557 192.147 123.233V123.249ZM216.754 129.312C216.215 130.228 214.192 130.759 212.237 130.486C210.282 130.212 209.136 129.247 209.675 128.315C210.214 127.382 212.237 126.851 214.192 127.125C216.147 127.398 217.293 128.363 216.754 129.296V129.312ZM179.573 110.013C180.079 110.962 178.916 111.895 176.944 112.136C174.972 112.377 172.983 111.782 172.461 110.833C171.938 109.884 173.135 108.952 175.09 108.726C177.045 108.501 179.051 109.112 179.573 110.045V110.013ZM244.176 128.733C244.699 129.666 243.519 130.614 241.564 130.84C239.609 131.065 237.586 130.486 237.08 129.553C236.575 128.62 237.738 127.655 239.727 127.478C241.715 127.301 243.671 127.784 244.176 128.733ZM179.742 97.871C179.202 98.8037 177.18 99.3344 175.225 99.0611C173.27 98.7877 172.124 97.8066 172.663 96.8739C173.202 95.9411 175.225 95.4265 177.18 95.6999C179.135 95.9733 180.281 96.9221 179.742 97.871ZM267.031 124.165C266.212 124.507 265.329 124.684 264.435 124.684C263.542 124.684 262.658 124.507 261.84 124.165C260.424 123.474 260.441 122.364 261.84 121.689C262.66 121.354 263.543 121.182 264.435 121.182C265.327 121.182 266.21 121.354 267.031 121.689C268.497 122.396 268.48 123.506 267.031 124.165ZM192.635 87.4979C191.816 87.8361 190.933 88.0105 190.04 88.0105C189.147 88.0105 188.264 87.8361 187.444 87.4979C186.028 86.7903 186.045 85.6806 187.444 85.0213C188.263 84.6794 189.146 84.5029 190.04 84.5029C190.933 84.5029 191.817 84.6794 192.635 85.0213C194.102 85.6646 194.085 86.8386 192.635 87.4979ZM281.863 112.248C281.323 113.165 279.301 113.696 277.346 113.422C275.391 113.149 274.244 112.168 274.784 111.251C275.323 110.335 277.346 109.788 279.301 110.061C281.256 110.335 282.402 111.396 281.863 112.248ZM217.445 79.5694C217.951 80.5183 216.788 81.4671 214.816 81.6923C212.844 81.9174 210.855 81.3384 210.349 80.3896C209.844 79.4407 211.007 78.508 212.962 78.2828C214.917 78.0577 216.939 78.6366 217.445 79.5694ZM282.048 98.2569C282.571 99.2058 281.391 100.139 279.436 100.364C277.48 100.589 275.458 100.01 274.952 99.0771C274.447 98.1444 275.61 97.1955 277.582 96.9704C279.554 96.7452 281.542 97.3242 282.048 98.2569ZM267.536 88.4468C266.716 88.7812 265.833 88.9536 264.941 88.9536C264.049 88.9536 263.166 88.7812 262.345 88.4468C260.913 87.7392 260.929 86.6295 262.345 85.9701C263.164 85.6282 264.047 85.4517 264.941 85.4517C265.834 85.4517 266.718 85.6282 267.536 85.9701C268.986 86.6617 268.969 87.7713 267.536 88.4468Z",
    fill: "#849FB4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.567 78.349C149.741 91.2148 149.454 112.572 176.91 126.097C204.366 139.622 249.182 140.201 277.008 127.368C304.835 114.534 305.139 93.1447 277.666 79.6035C250.193 66.0622 205.394 65.4994 177.567 78.349ZM237.805 78.2043C238.328 77.2715 240.35 76.7569 242.305 77.0303C244.26 77.3037 245.406 78.2686 244.867 79.2014C244.328 80.1342 242.322 80.6649 240.367 80.3915C238.412 80.1181 237.266 79.0567 237.805 78.2043ZM192.18 121.626C191.362 121.968 190.478 122.145 189.585 122.145C188.691 122.145 187.807 121.968 186.989 121.626C185.556 120.935 185.573 119.825 186.989 119.15C187.81 118.815 188.692 118.643 189.585 118.643C190.477 118.643 191.36 118.815 192.18 119.15C193.63 119.745 193.613 120.854 192.18 121.514V121.626ZM216.788 127.689C216.248 128.622 214.226 129.153 212.271 128.879C210.316 128.606 209.169 127.625 209.709 126.708C210.248 125.792 212.271 125.245 214.226 125.518C216.181 125.792 217.327 126.66 216.788 127.577V127.689ZM179.607 108.391C180.112 109.323 178.933 110.272 176.978 110.497C175.022 110.723 173.017 110.144 172.494 109.211C171.972 108.278 173.168 107.313 175.124 107.088C177.079 106.863 179.051 107.394 179.607 108.342V108.391ZM244.21 127.03C244.732 127.963 243.552 128.912 241.581 129.137C239.609 129.362 237.62 128.783 237.114 127.834C236.608 126.885 237.771 125.952 239.727 125.727C241.682 125.502 243.704 126.081 244.21 127.03ZM179.775 96.1681C179.236 97.1009 177.214 97.6316 175.258 97.3582C173.303 97.0848 172.157 96.1038 172.697 95.171C173.236 94.2383 175.258 93.7236 177.214 93.997C179.169 94.2704 180.315 95.2354 179.775 96.1681ZM267.064 122.463C266.245 122.801 265.362 122.975 264.469 122.975C263.576 122.975 262.693 122.801 261.873 122.463C260.457 121.755 260.474 120.645 261.873 119.986C262.693 119.648 263.576 119.473 264.469 119.473C265.362 119.473 266.245 119.648 267.064 119.986C268.531 120.694 268.514 121.803 267.064 122.463ZM192.669 85.7951C191.849 86.1296 190.966 86.302 190.073 86.302C189.181 86.302 188.298 86.1296 187.478 85.7951C186.062 85.0875 186.079 83.9778 187.478 83.3185C188.296 82.9766 189.18 82.8001 190.073 82.8001C190.967 82.8001 191.851 82.9766 192.669 83.3185C194.22 84.01 194.118 85.1197 192.669 85.7951ZM281.863 110.53C281.323 111.462 279.301 111.993 277.346 111.72C275.39 111.446 274.244 110.465 274.784 109.549C275.323 108.632 277.346 108.085 279.301 108.358C281.256 108.632 282.436 109.613 281.863 110.53ZM217.479 77.8666C217.984 78.8154 216.805 79.7643 214.849 79.9894C212.894 80.2146 210.889 79.6356 210.366 78.6868C209.844 77.7379 211.074 76.8052 212.995 76.5961C214.917 76.387 216.956 76.9338 217.479 77.8666ZM282.082 96.5541C282.604 97.4869 281.424 98.4357 279.469 98.6609C277.514 98.886 275.492 98.3071 274.986 97.3743C274.48 96.4415 275.643 95.4766 277.615 95.2515C279.587 95.0263 281.576 95.6053 282.082 96.5541ZM267.57 86.7279C266.752 87.0698 265.868 87.2463 264.974 87.2463C264.081 87.2463 263.197 87.0698 262.379 86.7279C260.946 86.0363 260.963 84.9267 262.379 84.2512C263.199 83.9168 264.082 83.7444 264.974 83.7444C265.867 83.7444 266.75 83.9168 267.57 84.2512C269.019 84.9588 269.003 86.0685 267.57 86.7279Z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.057 103.273C259.173 94.9065 245.052 87.9446 227.516 87.7226C209.981 87.5006 195.671 94.1028 195.555 102.469C195.439 110.835 209.56 117.797 227.095 118.019C244.631 118.241 258.94 111.639 259.057 103.273Z",
    fill: "#BFD4E4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.742 103.256C257.854 95.2364 244.317 88.5626 227.508 88.3499C210.698 88.1371 196.981 94.4659 196.869 102.486C196.758 110.505 210.294 117.179 227.104 117.392C243.913 117.605 257.631 111.276 257.742 103.256Z",
    fill: "#F2F7F9"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.565 46.6243C341.087 31.8843 345.653 20.601 354.262 12.7744C362.871 4.81737 374.872 0.838867 390.264 0.838867C400.308 0.838867 408.852 2.59985 415.896 6.12181C423.07 9.51332 428.484 14.2093 432.136 20.2096C435.789 26.0796 437.615 32.7321 437.615 40.1674C437.615 49.0375 435.463 56.1466 431.158 61.4948C426.853 66.7125 421.962 70.2345 416.483 72.0607V72.8433C432.267 78.7133 440.158 89.9313 440.158 106.498C440.158 114.715 438.267 121.955 434.484 128.216C430.701 134.478 425.223 139.369 418.048 142.891C410.874 146.413 402.33 148.174 392.416 148.174C376.111 148.174 363.197 144.261 353.675 136.434C344.283 128.477 339.391 116.346 339 100.041H376.372C376.111 105.258 377.22 109.302 379.698 112.172C382.177 115.042 385.894 116.476 390.851 116.476C394.634 116.476 397.569 115.302 399.656 112.955C401.873 110.607 402.982 107.476 402.982 103.563C402.982 98.6058 401.352 94.9534 398.091 92.6054C394.96 90.2575 389.807 89.0835 382.633 89.0835H375.785V57.9728H382.437C387.394 58.1033 391.568 57.3206 394.96 55.6249C398.482 53.7987 400.243 50.2115 400.243 44.8633C400.243 40.8196 399.265 37.8194 397.308 35.8628C395.351 33.7757 392.677 32.7321 389.286 32.7321C385.503 32.7321 382.698 34.1018 380.872 36.8411C379.176 39.45 378.198 42.711 377.937 46.6243H340.565Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 154.68,
    y: 68.4593,
    width: 145.222,
    height: 71.2131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.912989
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 195.554,
    y: 87.7172,
    width: 63.5033,
    height: 30.3071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608659
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.0985,
    y1: -34.7326,
    x2: 118.459,
    y2: 173.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 138.239,
    y1: 104.287,
    x2: 315.366,
    y2: 104.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1BACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 150.518,
    y1: 86.1847,
    x2: 303.093,
    y2: 86.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BCD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBD1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BBD1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C5D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 225.571,
    y1: 70.0058,
    x2: 228.04,
    y2: 142.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7992A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#627889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 167.158,
    y1: 78.8065,
    x2: 280.368,
    y2: 134.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 186.635,
    y1: 75.1545,
    x2: 273.673,
    y2: 127.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 359.363,
    y1: -31.6108,
    x2: 452.723,
    y2: 176.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403Manhole);
export default __webpack_public_path__ + "static/media/error_403_manhole.35cc929906764935d75c7e91b76fdd2d.svg";
export { ForwardRef as ReactComponent };